
import React, { useEffect, useState, useRef, createRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import TituloComponent from '../../components/Titulo/TituloComponent';
import Carregando from '../../components/Carregando/Carregando';
import { buscarPedidosEntreguesNaMesa, criarCheckoutPagBank, quitarConta, 
  criarPagamentoPagBankGerandoToken, getChavePublica } from '../../services/api';
// cookies
import Cookies from 'js-cookie';
// serviços de cliente
import { atualizarDadosClienteLogado, getFinalCartaoUsuarioLogado } from '../../services/clienteService';

// css
import '../../styles/global.css';
import './PedidosEntreguesNaMesa.css';

/* eslint-disable no-restricted-globals */

const PedidosEntreguesNaMesa = () => {

    const navigate = useNavigate();
    // const nomeCliente = dadosCheckin?.statusCheckin.nome;

    const [pedidos, setPedidos] = useState([]);
    const [carregando, setCarregando] = useState(true);

    // buscar os pedidos periodicamente
    const [intervalId, setIntervalId] = useState(null);

    // vamos pegar o dadosCheckin dos cookies
    // const dadosCheckin = JSON.parse(sessionStorage.getItem('dadosCheckin')) || {};
    const dadosCheckin = JSON.parse(Cookies.get('dadosCheckin')) || {};
    const nomeCliente = dadosCheckin.nome;
    const cpfClienteCheckin = dadosCheckin.numeroCpf;
    const nomeEstabelecimento = dadosCheckin.estabelecimento.nome;

    // dados do usuário, inclusive se for cliente logado
    const userData = JSON.parse(sessionStorage.getItem('userData')) || {};

    // vamos verificar o perfil do usuário
    const perfilUsuario = userData && userData.dadosPerfil ? userData.dadosPerfil.nome : null;

    var valorTotalConta = 0;

    useEffect(() => {
        console.log('----- ENTROU NO PedidosEntreguesNaMesa -----');

        console.log('cpf do cliente: ');
        console.log(cpfClienteCheckin);

        // vamos chamar o método que faz as verificações do checkin, inclusive nos cookies.
        // verificarDadosCheckin();  // se for verificado o checkin, já será redirecionado.

        // chamar o método que atualiza os dados do cliente logado
        atualizarDadosClienteLogado(userData);

        // vamos chamar o método que carrega os dados
        loadData();

    }, []);


    useEffect(() => {
        const id = setInterval(fetchPedidos, 10000); // 30 segundos
        setIntervalId(id);
        return () => clearInterval(id);
    }, []);


    
    // método que pega a localização e busca os estabelecimentos
    const loadData = async () => {
        console.log(' *** Entrou no loadData ***');
        console.log('Dados do checkin: ');
        console.log(dadosCheckin);
        try {
            await fetchPedidos(); 
        } catch (err) {
            console.log("Erro ao buscar os pedidos:", err);
        }
    };





  // buscar todos os produtos do estabelecimento, para checkar os que já tem
  const fetchPedidos = async () => {
    console.log('Entrou em fetchPedidos em PedidosEntreguesNaMesa');

    try {
      const dados = await buscarPedidosEntreguesNaMesa(dadosCheckin);

      console.log('*** pedidos ***', dados.pedidos);

      if (dados?.pedidos) {
        console.log('-> Pedidos: ', dados.pedidos);
        setPedidos(dados.pedidos);
        setCarregando(false);
      }
    } catch (error) {
      console.error('Erro ao buscar produtos:', error);
    }
  };


  if (carregando) {
    return <Carregando />;
  }

  // fazer o checkout no pagbank
  const handleCriarCheckoutPagBank = async () => {
    console.log('-------------------------------');
    console.log('Entrou em criarCheckoutPagBank em PedidosEntreguesNaMesa');

    try {
      const dados = await criarCheckoutPagBank(pedidos, cpfClienteCheckin);

      console.log('Dados recebidos: ');
      console.log(dados);

      console.log('Links:');
      console.log(dados.response.links);

      const payLink = dados.response.links.find(item => item.rel === 'PAY').href;

      // redirecionar cliente para pagamento pagbank
      window.location.href = payLink;

    } catch (error) {
      if (error.response && error.response.status === 422) {
        alert('CPF inválido!!!');
      }
      console.error('Erro ao fazer o checkout no PagBank:', error);
    }
  };



  const handleQuitarConta = async () => {
    console.log('Entrou em quitarConta');
    console.log('Pedidos:');
    console.log(pedidos);

    try {
      const dados = await quitarConta(pedidos);
      console.log('Dados recebidos: ');
      console.log(dados);
      alert('Conta paga com sucesso!');
      navigate('/usuario-checkado');

    } catch (error) {
      console.error('Erro ao quitar a conta!', error);
    }

  }
  

  /**
   * Método que criptografa o cartão
   */
  const handleEncryptCard = async (chavePublica) => {
    console.log('Entrou em handleEncryptCard...');
    if (!window.PagSeguro) {
      alert('SDK do PagSeguro ainda não foi carregada!');
      return;
    }
  
    const card = window.PagSeguro.encryptCard({
      // publicKey: chavePublica,
      publicKey: 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAr+ZqgD892U9/HXsa7XqBZUayPquAfh9xx4iwUbTSUAvTlmiXFQNTp0Bvt/5vK2FhMj39qSv1zi2OuBjvW38q1E374nzx6NNBL5JosV0+SDINTlCG0cmigHuBOyWzYmjgca+mtQu4WczCaApNaSuVqgb8u7Bd9GCOL4YJotvV5+81frlSwQXralhwRzGhj/A57CGPgGKiuPT+AOGmykIGEZsSD9RKkyoKIoc0OS8CPIzdBOtTQCIwrLn2FxI83Clcg55W8gkFSOS6rWNbG5qFZWMll6yl02HtunalHmUlRUL66YeGXdMDC2PuRcmZbGO5a/2tbVppW6mfSWG3NPRpgwIDAQAB',
      holder: userData.dadosCliente.nome_como_esta_no_cartao,
      number: userData.dadosCliente.numero_cartao,
      expMonth: userData.dadosCliente.mes_validade_cartao,
      expYear: userData.dadosCliente.ano_validade_cartao,
      securityCode: userData.dadosCliente.codigo_cartao,
    });
  
    if (card.hasErrors) {
      console.error('Erros na criptografia do cartão:', card.errors);
      alert('Erro nos dados do cartão.');
      return;
    }

    const cartaoCriptografado = card.encryptedCard;
  
    console.log('Cartão criptografado (em handleEncryptCard...):');
    console.log(cartaoCriptografado);
    console.log('Tamanho do cartão criptografado:');
    console.log(cartaoCriptografado ? cartaoCriptografado.length : null);


    // encryptedCard = encodeURIComponent(card.encryptedCard);

    return card.encryptedCard;

  };
  




  // gerar o pagamento, gerando o token para utilização futura
  const handleCriarPagamentoPagBankGerandoToken = async (e) => {
    console.log('--- ============== ---');
    console.log('Entrou em handleCriarPagamentoGerandoToken em MinhasFichas.js');

    e.preventDefault();
    /**
     * Precisaremos buscar a chave pública para criptografarmos o cartão
     */
    let chavePublica = null;

    // const responseChavePublica = await getChavePublica();
    // console.log('Response da have pública recebida:', responseChavePublica);
    // chavePublica = responseChavePublica.chavePublica;

    // vamos verificar se a SDK do pagseguro já foi carregada
    console.log('Verificando se a sdk do pagseguro foi carregada...');
    if (!window.PagSeguro) {
      alert('SDK do PagSeguro ainda não foi carregada!');
      return;
    }
    console.log('ok, sdk carregada!');

    console.log('Vamos buscar a chave pública....');

    // Aqui quer dizer que a sdk do pagseguro foi carregada
    try {
      const responseChavePublica = await getChavePublica();
      console.log('Response da have pública recebida:', responseChavePublica);
      chavePublica = responseChavePublica.chavePublica;

      console.log('chave pública: ');
      console.log(chavePublica);

    } catch (error) {
      console.error('Erro ao receber a chave pública:', error);
      // Exibe a mensagem de erro vinda da API
      const errorMessage = error.response?.data?.message || 'Erro ao receber a chave pública.';
      alert(errorMessage);
    }

    /**
     * Agora com a chave pública em mãos, vamos criptografar o cartão
     */
    const cartaoCriptografado = await handleEncryptCard(chavePublica);
    userData.dadosCliente.cartao_criptografado_pagbank = cartaoCriptografado;
    sessionStorage.setItem('userData.dadosCliente.cartao_criptografado_pagbank', JSON.stringify(cartaoCriptografado));

    // console.log('userData: ');
    // console.log(userData);

    try {
      const dados = await criarPagamentoPagBankGerandoToken(pedidos, userData);

      console.log('!!!!!! Dados recebidos do checkout após criar pagamento gerando token: ');
      console.log(dados);

      alert('Pagamento efetuado com sucesso!');

      navigate('/');

      // console.log('Links:');
      // console.log(dados.response.links);

      // const payLink = dados.response.links.find(item => item.rel === 'PAY').href;

      // // redirecionar cliente para pagamento pagbank
      // window.location.href = payLink;

    } catch (error) {
      if (error.response && error.response.status === 422) {
        alert('CPF inválido!!!');
      }
      console.error('Erro ao fazer o checkout no PagBank:', error);
    }
  };








  return (
    <div autoFocus className="fichas-container">
      <TituloComponent />

      <h1 className="sub-titulo">Pedidos já recebidos na mesa</h1>

      {
        pedidos.length > 0 && (
          <div className="box-dados">
            <p className="texto-welcome">{nomeCliente},</p>
            <p className="texto-welcome">Bem-vindo ao {nomeEstabelecimento}!</p>
          </div>
        )
      }

    {/* Container de quadros */}
    <div className="box-dados">
        {pedidos.map((pedido, index) => {

            const valor = pedido.preco * pedido.quantidade;
            const statusPedido = pedido.status_pedido;
            const arrayStatusPedidoPago = [
              'PEDIDO PAGO PELO CLIENTE', 'FICHA PAGA PELO CLIENTE'
            ];
            
                      // aqui fazer a verificação - só mostraremos se o status não estiver no array
          if(!arrayStatusPedidoPago.includes(statusPedido)){
            valorTotalConta = (valorTotalConta + valor);
            return (
              <div key={index}>
                  <p className="texto-welcome">
                  {pedido.quantidade} {pedido.nome_produto} R$ {valor}
                  </p>
                  <div className="divisor">&nbsp;</div>
              </div>
              );
          }



        })}
        
        <p className="texto-welcome">Total a pagar: R$ {valorTotalConta}</p>

        {
          pedidos.length > 0 ? (

              // se o usuário estiver logado, mostraremos o cartão que será utilizado
              userData.statusUsuario == 'logado' && perfilUsuario == 'BAR CLIENTE'
              ?
                <div className="box-dados">           
                  <div className="form-group">

                    {
                      valorTotalConta > 0
                      ?
                        <>
                        <label htmlFor="numeroMesa">Cartão salvo: final {getFinalCartaoUsuarioLogado(userData)} </label>
                        <button onClick={handleCriarPagamentoPagBankGerandoToken}>
                          Pagar com cartão salvo
                        </button>
                        </>
                      :
                        null
                    }

                  </div>

                </div>
              :
                  <div className="form-group">
                    {
                      valorTotalConta > 0
                      ?
                        <>
                          <label htmlFor="numeroMesa">Você não possui cartão salvo</label>

                          <hr></hr>

                          <label htmlFor="numeroMesa">Informar os dados no ato do pagamento</label>
                          <button onClick={handleCriarCheckoutPagBank}>
                            Pagar no PagBank
                          </button>
                        </>
                      :
                        null
                    }
                  </div>

          ) : (
            <p className="texto-ficha-usar">Você não fez nenhum pedido</p>
          )
        }
        

    </div>


      {/* Container de quadros */}
      {pedidos.map((pedido, index) => (
          console.log('pedido = ', pedido),
          <div
          // Chave composta, pois um mesmo pedido pode ter mais de um produto.
            key={`${pedido.id}-${pedido.produto_estabelecimento_id}`}  
            data-index={index} // O índice para o swipeHandler identificar
            data-id={pedido.id} // O ID do pedido
            className="box-dados-ficha"
          >

          <p className="texto-ficha-numero">{pedido.produto_pedido_id}</p>
          <p className="texto-welcome">Mesa {pedido.numero_mesa} - Comanda {pedido.numero_comanda}</p>

          <div className="divisor">&nbsp;</div>

          <p className="texto-ficha-nome-produto">{pedido.nome_produto}</p>

          <div className="divisor">&nbsp;</div>

          <p className="texto-welcome">Quantidade: {pedido.quantidade}</p>
          <p className="texto-welcome">Data: {pedido.data_pedido} - {pedido.hora_pedido}</p>

          <div className="divisor">&nbsp;</div>

          <p className="texto-status">Status: {pedido.status_pedido}</p>

        </div>
      ))}
    </div>
  );
};

export default PedidosEntreguesNaMesa;

